import { render } from "./LoginView.vue?vue&type=template&id=8cd4a2b4"
import script from "./LoginScript.vue?vue&type=script&lang=js&external"
export * from "./LoginScript.vue?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__